

export default () => {
  return {
    id: null,
    name: '',
    users: null,
    phone: '',
    phoneExt: '',
    fax: '',
    faxExt: '',
    website: '',
    email: '',
    created_at: null,
    updated_at: null,
    inactive: null,
    maintenance_mode: null,
    hasPowerPoints: false,
    hasReferenceFiles: false,
    hasFileSharing: false,
  }
}
